/**
 * Author: Claude Code
 * Version: v3.0.84
 * Modified: 2025-09-09 Beijing Time
 * 
 * Game Configuration - Phaser游戏配置
 * 统一管理GameContainer和游戏系统的配置参数
 */

import type { GameConfig } from '../GameContainer';

export const GAME_CONFIG: GameConfig = {
  width: 1024,
  height: 768,
  backgroundColor: '#1a1a2e',
  parent: 'phaser-game',
  scenes: ['LoadingScene', 'BattleScene', 'MenuScene', 'ReplayScene'] // P0.4: Added LoadingScene
};

// Agent registration configuration
export const AGENT_CONFIG = {
  MAX_AGENTS: 5,
  TOTAL_ATTRIBUTE_POINTS: 150,
  ATTRIBUTE_LIMITS: {
    MIN: 10,
    MAX: 50
  },
  SPAWN_MIN_DISTANCE: 3.0 // Grid units
} as const;

// Map configuration for agent spawning
export const SPAWN_MAP_BOUNDS = {
  minX: 2,
  maxX: 23,
  minY: 2,
  maxY: 17
} as const;

// Game phases
export const GAME_PHASES = {
  REGISTRATION: 'registration',
  PREPARATION: 'preparation',
  BATTLE: 'battle',
  RESULTS: 'results'
} as const;

// Default agent configuration template
export const DEFAULT_AGENT_CONFIG = {
  hp: 30,
  attack: 30,
  defense: 30,
  speed: 30,
  aggressiveness: 30
} as const;